import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  async toggle(event) {
    event.preventDefault()

    const button = event.currentTarget
    const baseUrl = button.dataset.url
    if (!baseUrl) return

    const isExpanded = button.dataset.expanded === "true"
    const url = new URL(baseUrl, window.location.origin)
    url.searchParams.set("open", isExpanded ? "0" : "1")

    const response = await fetch(url.toString(), {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin"
    })

    if (!response.ok) return

    Turbo.renderStreamMessage(await response.text())

    button.dataset.expanded = (!isExpanded).toString()
    const expandedNow = !isExpanded
    button.textContent = expandedNow ? "-" : "+"
    button.setAttribute("aria-label", expandedNow ? "Verberg details" : "Toon details")
  }

  async refreshSingleDetail(event) {
    const detailLevel = event.currentTarget.value
    const domKey = event.currentTarget.dataset.domKey
    if (!detailLevel || !domKey) return

    const button = this.element.querySelector(`button[data-dom-key="${domKey}"][data-url]`)
    if (!button) return

    const buttonBaseUrl = button.dataset.url
    if (!buttonBaseUrl) return

    const detailUrl = new URL(buttonBaseUrl, window.location.origin)
    detailUrl.searchParams.set("detail_level", detailLevel)
    detailUrl.searchParams.set("open", "1")

    const response = await fetch(detailUrl.toString(), {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin"
    })

    if (!response.ok) return

    Turbo.renderStreamMessage(await response.text())

    detailUrl.searchParams.delete("open")
    button.dataset.url = `${detailUrl.pathname}?${detailUrl.searchParams.toString()}`
  }
}
